module.exports = __webpack_public_path__ + "img/define.0ebb7dac.png";